import {NgModule} from '@angular/core';

import {StampComponent} from './stamp/stamp.component';

@NgModule({
  declarations: [StampComponent],
  exports: [StampComponent],
})
export class StampsModule {}
